export const SEASONAL_RECOMMENDATION_INTENT = Object.freeze({
  SHUFFLE: 'shuffle',
  INITIAL_SETUP: 'initial_setup',
  SEASONAL_TAG_CHANGE: 'seasonal_tag_change',
  USE_DEFAULT_TIMING: 'use_default_timing',
})

export const SEASONAL_RECOMMENDATION_RESULT = Object.freeze({
  APPLIED: 'applied',
  WAITING: 'waiting',
  FAILED: 'failed',
  STALE: 'stale',
})
